export default __webpack_public_path__ + "static/media/login.4d7f5652.jpeg";